import styled from 'styled-components';

import { ButtonProps } from '../Button';

export const ButtonContentWrapper = styled.div<Pick<ButtonProps, 'isLoading'>>`
    display: flex;
    align-items: center;
    opacity: ${(props) => (props.isLoading ? 0 : 1)};
`;
